import { LoadableAfterPaint } from '@confluence/loadable';

export const RtPaidFeatureEducationSpotlightTargetLoadable = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-RtPaidFeatureEducationSpotlightTarget" */ '../../src/ui/RtPaidFeatureEducationSpotlightTarget'
			)
		).RtPaidFeatureEducationSpotlightTarget,
});
